export default "__VITE_ASSET__CmSHlUEo__"